import * as React from 'react'
import LogInForm from '@App/components/forms/LogInForm'
import { BLIINK_COPYRIGHT } from '@App/constantes'
import { Title } from 'relevant-ui'
import './styles.scss'

class LoginPage extends React.Component<any, any, any> {
  constructor(props: any) {
    super(props)

    this.state = {
      width: window.innerWidth,
      height: 0,
    }
  }

  componentWillMount() {
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = (event: Object) => {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  }

  render() {
    const {
      width,
    } = this.state

    return (
      <div className="loginPage">
        <div className="loginPage__wrapper">
          <Title
            title="Connexion à BLIINK."
            subtitle="Entrez vos indentifiants ci-dessous."
            color={width <= 991 ? 'white' : 'black'}
          />
          <LogInForm />
        </div>
        <h3 className="loginPage__copyright">{BLIINK_COPYRIGHT}</h3>
      </div>
    )
  }
}

export default LoginPage
